<template>
  <div class="message">
    <div class="retreat" @click="retreat">
      <van-icon name="arrow-left" color="#fff" />
    </div>
    <div class="title">{{$t('message.user.message_list')}}</div>
    <div class="context">
      <!-- 入围桐通知 -->
      <!-- 跳转页面 ToInform(name值) -->
      <div class="finalist_inform"  v-for="item in listall" :key="item.id" @click="ToInform(item.messageType, item.id)">
        <div class="finalist_inform">
          <img :src="item.image" alt="">
          <div class="show" >
            <div class="finalist_inform_icon_red" v-if="item.notRead"> </div>
          </div>
        </div>

        <div class="finalist_inform_text">
          <div class="finalist_inform_text_title">{{ item.messageType }}</div>
          <div class="finalist_inform_text_context">
            {{ item.content }}
          </div>
          <div class="finalist_inform_text_time">
            <span>{{ item.createTime | date }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import { listAll } from '@/api/activity.js'
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      listall: [],
      show:true
    }
  },
  filters: {
    date: (val) => {
      var year = new Date().getFullYear()
      const a = val.split('年')
      if (year == a[0]) {
        return a[1]
      }
    }
  },
  //监听属性 类似于data概念
  computed: {
    ...mapState(['JoinShowHidden', 'VictoryShowHidden']),
    ...mapMutations(['alterJoinShowHidden', 'alterVictoryShowHidden'])
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    retreat() {
      // 返回上一级
      this.$router.go(-1)
    },
    ToInform(messageType, parentId) {
      this.$router.push({
        name: 'finalistPage',
        query: { parentId: parentId, messageType: messageType }
      })
      // this.finalistisShow=false  // 点击后表示进入页面 不需要小红点
      // switch (na) {
      //   case 'finalistPage':
      //     this.alterJoinShowHidden
      //     break
      //   case 'prizePage':
      //     this.alterVictoryShowHidden
      //     break
      //}
      // 点击跳转到消息列表
    },

    async listAll() {
      const { data: res } = await listAll()
      this.listall = res.data
     
    }
  },
  //生命周期 - 创建完成(可以访问当前this实例)
  created() {
    this.listAll()
  },
  //生命周期 - 挂载完成(可以访问DOM元素)
  mounted() { }
}
</script>
<style scoped lang="less">
.message {
  width: 100%;
  //height: 100vh;
  overflow: auto;
  box-sizing: border-box;
  background-size: 100%;
  background-image: url('../../../static/image/user_bjt.png');
  background-repeat: no-repeat;
  position: relative;

  .retreat {
    position: absolute;
    top: 44px;
    left: 26px;
  }

  .title {
    text-align: center;
    font-size: 16px;
    color: #fff;
    margin-top: 43px;
  }

  .context {
    box-sizing: border-box;
    width: 100%;
    //height: 100vh;
    background-color: #fff;
    margin-top: 15px;
    border-radius: 30px 30px 0 0;
    padding: 40px 15px 0 25px;

    .finalist_inform {

      height: 60px;
      display: flex;
      align-items: center;
      position: relative;

      img {
        width: 38px;
        height: 38px;
        //background: #fff url('../../../static/image/huojian.png') no-repeat center;
        background-size: 32px 32px;
        margin-right: 8px;
        position: relative;

      }

      .finalist_inform_icon_red {
        position: absolute;
        top: 9px;
        right: 4px;
        width: 12px;
        height: 12px;
        background-color: #f83e3e;
        border-radius: 50%;
      }

      .finalist_inform_text {
        margin-left: 0px;
      }

      .finalist_inform_text_title {
        font-size: 14px;
        margin-bottom: 3px;
      }

      .finalist_inform_text_context {
        color: #999999;
        font-size: 10px;
        width: 265px;
        /*要显示文字的宽度*/
        text-overflow: ellipsis;
        /*让截断的文字显示为点点。还有一个值是clip意截断不显示点点*/
        white-space: nowrap;
        /*让文字不换行*/
        overflow: hidden;
        /*超出要隐藏*/
      }

      .finalist_inform_text_time {
        color: #999999;
        font-size: 10px;
        position: absolute;
        top: 0;
        right: 0;
        margin-top: 12px;
      }

      .finalist_inform_text_time span:nth-child(1) {
        margin-right: 5px;
      }
    }

    .prize_inform {
      width: 100%;
      height: 60px;
      display: flex;
      align-items: center;
      position: relative;

      .prize_inform_icon {
        width: 38px;
        height: 38px;
        background: #fff url('../../../static/image/jiangbei.png') no-repeat center;
        background-size: 32px 32px;
        margin-right: 8px;
        position: relative;

        .prize_inform_icon_red {
          position: absolute;
          top: -2px;
          right: 1px;
          width: 12px;
          height: 12px;
          background-color: #f83e3e;
          border-radius: 50%;
        }
      }

      .prize_inform_text_title {
        font-size: 14px;
        margin-bottom: 3px;
      }

      .prize_inform_text_context {
        color: #999999;
        font-size: 10px;
        width: 265px;
        /*要显示文字的宽度*/
        text-overflow: ellipsis;
        /*让截断的文字显示为点点。还有一个值是clip意截断不显示点点*/
        white-space: nowrap;
        /*让文字不换行*/
        overflow: hidden;
        /*超出要隐藏*/
      }

      .prize_inform_text_time {
        color: #999999;
        font-size: 10px;
        position: absolute;
        top: 0;
        right: 0;
        margin-top: 12px;
      }

      .prize_inform_text_time span:nth-child(1) {
        margin-right: 5px;
      }
    }
  }
}
</style>
